import "./Footer.css";
import thevisualdesigner from "../../Images/Brand/@thevisualdesigner.png";
import { useNavigate } from "react-router-dom";
const Footer = () => {
    const LinkTo = useNavigate();
    return (
        <>
            <div className="footerBack">
                <div className="footer">
                    {/* <div className="footerUpperLayer"> */}

                    {/* </div> */}
                    <div className="brandInfoFooter">
                        <img src={thevisualdesigner} alt="" />
                        <div className="texts">
                            <div className="text">Bhanubhakta_Sapkota</div>
                            <div className="text">Graphic Designer</div>
                        </div>
                    </div>

                    <div className="footerLinksInfo">
                        <div className="footerLinks">
                            <div className="footerTitle">
                                Pages
                            </div>
                            <div className="footerPages">
                                <div className="multipleColumn">
                                    <div onClick={()=> LinkTo("/")} className="footerLink">
                                        Home
                                    </div>
                                    <div onClick={()=> LinkTo("/about")} className="footerLink">
                                        About
                                    </div>
                                    <div onClick={()=> LinkTo("/contact")} className="footerLink">
                                        Contact
                                    </div>
                                </div>
                                <div className="multipleColumn">
                                    <div onClick={()=> LinkTo("/works")} className="footerLink">
                                        Work
                                    </div>
                                    <div onClick={()=> LinkTo("/blogs")} className="footerLink">
                                        Blogs
                                    </div>
                                    <div className="footerLink">
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="footerLinks">
                            <div className="footerTitle">
                                Contact
                            </div>
                            <div className="footerPages">
                                <div className="multipleColumn">
                                    <div className="footerLink">
                                        .
                                    </div>
                                    <div className="footerLink">
                                        9816185204
                                    </div>
                                    <div className="footerLink">
                                       hellothevisualdesigner@gmail.com
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="copyRight">
                        <div className="copyRightTxt">
                            © 2025 By
                        </div>
                        <div className="copyRightTxt">
                            thevisualdesigner / Bhanubhakta Sapkota
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Footer;